import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// GLOBAL error suppression during login/logout - works in all environments
const originalError = window.onerror;
window.onerror = function(msg, url, line, col, error) {
  // Suppress ALL errors during login/logout - no exceptions
  if (window.isLoggingIn || window.isLoggingOut) {
    return true; // Suppress
  }
  // Call original error handler for other errors
  if (originalError) {
    return originalError.apply(this, arguments);
  }
  return false;
};

// Also handle unhandled promise rejections
const originalUnhandledRejection = window.onunhandledrejection;
window.onunhandledrejection = function(event) {
  // Suppress ALL promise rejections during login/logout
  if (window.isLoggingIn || window.isLoggingOut) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
  // Call original handler for other errors
  if (originalUnhandledRejection) {
    return originalUnhandledRejection.apply(this, arguments);
  }
  return false;
};

// Development-specific: Disable React Error Overlay during login/logout
if (process.env.NODE_ENV === 'development') {
  // Monitor for error overlay and remove it during login/logout
  const observer = new MutationObserver(() => {
    if (window.isLoggingIn || window.isLoggingOut) {
      // Remove React error overlay
      const overlay = document.getElementById('react-error-overlay');
      if (overlay) {
        overlay.remove();
      }
      // Also remove any error overlay divs
      const errorOverlays = document.querySelectorAll('[data-react-error-overlay], iframe[title*="error"]');
      errorOverlays.forEach(el => {
        try {
          el.remove();
        } catch (e) {
          // Ignore
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
